
/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  locale: string,
  slug: string
};

/**
 * Export `fetchProductPdf`.
 */

export async function fetchProductPdf({ locale, slug }: Query) {
  const endpoint = getApiEndpoint('getProductPdf', { slug });

  try {
    return await request.get(endpoint, {
      headers: acceptLanguageHeader(locale),
      responseType: 'blob'
    });
  } catch (error) {
    handleRequestError(error);
  }
}
